import type { ProcessLogPayload } from "schemas/generated/agentConnection";

import { createShallowStore } from "replo-utils/react/zustand";

/**
 * NOTE (Noah, 2026-02-19, REPL-23937): Store for process logs from sandbox supervisor.
 * Logs are sent from the DO to superuser connections and stored here for display
 * in the debug panel.
 */

export const MAX_LOGS = 10_000;

type DebugSandboxProcessLogsState = {
  logs: ProcessLogPayload[];
  actions: {
    addLog: (log: ProcessLogPayload) => void;
    clearLogs: () => void;
  };
};

const useDebugSandboxProcessLogsStore =
  createShallowStore<DebugSandboxProcessLogsState>((set) => ({
    logs: [],
    actions: {
      addLog: (log: ProcessLogPayload) => {
        set((state) => {
          const next = [...state.logs, log];
          if (next.length > MAX_LOGS) {
            return { logs: next.slice(next.length - MAX_LOGS) };
          }
          return { logs: next };
        });
      },
      clearLogs: () => {
        set({ logs: [] });
      },
    },
  }));

// Hook selectors for React components
export const useDebugSandboxProcessLogs = () => {
  return useDebugSandboxProcessLogsStore((state) => state.logs);
};

export const useDebugSandboxProcessLogsActions = () => {
  return useDebugSandboxProcessLogsStore((state) => state.actions);
};
